/**
 * @file index.js
 * @author Daniel Aguirre
 * @description Initialize NutritionalIndicator View.
 */

// Commons
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';

// View
import View from './NutritionalIndicatorView';

export const mapStateToPropsNutritionalIndicator = mapStateToProps;
export const mapDispatchToPropsNutritionalIndicator = mapDispatchToProps;

export default connect(
  mapStateToPropsNutritionalIndicator,
  mapDispatchToPropsNutritionalIndicator
)(View);
